import React, { useState } from 'react'
import { Dropdown, Menu } from 'antd'
import Select from 'react-select'

import { AiOutlineDown, AiOutlineReload } from 'react-icons/ai'

import Receive from '../../components/reusable/receive'

import EditHostedDocument from '../../components/drawers/editHostedDocument'
import NewHostedDocument from '../../components/drawers/newHostedDocument'

import { stringifyDate, useListData, usePet, useToggle } from '../../modules'
import Confirm from '../../components/reusable/confirm'

const Documents = () => {
    const [selected, setSelected] = useState()
    const [string, setString] = useState('')
    const [active, setActive] = useState()

    const [newDocModal, toggleNewDocModal] = useToggle()
    const [docModal, toggleDocModal] = useToggle()

    const select = doc => {
        setSelected(doc)
        toggleDocModal()
    }
    
    const [
        { loading, error, fetch }, 
        { list: documents }, 
        { navigate, Paginate, page = 1, limit = 10 }
    ] = useListData('hostedDocuments', { string, active: active?.value }, { notify: true, manual: false }, 'documents')

    const refresh = () => {
        navigate(1)
        fetch()
    }

    const search = str => {
        setString(str)
        refresh()
    }
    
    const onComplete = ({ data }, notif, ops) => {
        notif(`Document has been ${selected?.active ? 'deactivated' : 'activated' }`, ops('success'))        
        refresh()
    }

    const [, execute] = usePet('toggleDocumentActiveStatus', { id: selected?._id }, { notify: true, callback: onComplete, manual: true })
    const [, deleteDocument] = usePet('deleteHostedDocument', { id: selected?._id }, { notify: true, callback: ({ data }, notif, ops) => {
        notif("Document has been deleted", ops('success'))        
        refresh()
    }, manual: true })

    const toggleActive = doc => {
        setSelected(doc)
        execute()        
    }

    const deleteDoc = doc => {
        setSelected(doc)

        Confirm({
            title: 'Delete Document?',
            message: 'Are you sure you want to delete this document?',
            okText: "Delete Document",
            onOk: deleteDocument,
            severity: 'danger'
        })
    }
    
    const changeStatus = val => {
        setActive(val)
        refresh()
    }

    return (
        <div className="px-4 sm:px-6 lg:px-8 py-8 w-full mx-auto">
            {
                newDocModal &&
                <NewHostedDocument
                    onPerform={ refresh }
                    toggle={ toggleNewDocModal }
                    visible={ newDocModal } />
            }            
            {
                docModal &&
                <EditHostedDocument
                    onPerform={ refresh }
                    doc={ selected }
                    toggle={ toggleDocModal }
                    visible={ docModal } />
            }
            <div className="sm:flex sm:justify-between sm:items-center mb-8">
                <input
                    onChange={e => search(e.target.value)}
                    className="appearance-none block max-w-4xl bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white"
                    id="grid-search"
                    type="text"
                    placeholder="Search by Name" />
                <div className="grid grid-flow-col sm:auto-cols-max justify-start sm:justify-end gap-2">
                    <button onClick={ toggleNewDocModal } className="btn hisani-btn-green-light text-white">
                        <svg className="w-4 h-4 fill-current opacity-50 flex-shrink-0" viewBox="0 0 16 16">
                            <path d="M15 7H9V1c0-.6-.4-1-1-1S7 .4 7 1v6H1c-.6 0-1 .4-1 1s.4 1 1 1h6v6c0 .6.4 1 1 1s1-.4 1-1V9h6c.6 0 1-.4 1-1s-.4-1-1-1z" />
                        </svg>
                        <span className="hidden xs:block ml-2">Add New Document</span>
                    </button>
                </div>
            </div>
            <div className="col-span-full xl:col-span-8 bg-white shadow-lg rounded-sm border border-gray-200">
                <header className="px-5 py-4 border-b border-gray-100 flex justify-between items-center">
                    <h2 className="font-semibold text-gray-800">Hosted Documents</h2>
                    <span className="flex items-center justify-between">
                        <Select
                            isClearable
                            value={ active }
                            onChange={ changeStatus }
                            styles={{ input: styles => ({ ...styles, minWidth: '10em' }) }}
                            options={['Active', 'Inactive']?.map(stat => ({ label: stat, value: stat === 'Active' }))}
                            placeholder="Select status" />
                        <button onClick={refresh} className="btn ml-2 py-3 hisani-btn-green-light text-white">
                            <AiOutlineReload style={{ color: "white" }} />
                        </button>
                    </span>
                </header>
                <div className="p-3">

                    {/* Table */}
                    <div className="overflow-x-auto">
                        <Receive
                            error={error}
                            loading={loading}
                            progress>
                            {
                                documents.length > 0 ?
                                    <table className="table-auto w-full">
                                        {/* Table header */}
                                        <thead className="text-xs uppercase text-gray-400 bg-gray-50 rounded-sm">
                                            <tr>
                                                <th className="p-2">
                                                    <div className="font-semibold text-center">No</div>
                                                </th>
                                                <th className="p-2">
                                                    <div className="font-semibold text-left">Name</div>
                                                </th>
                                                <th className="p-2">
                                                    <div className="font-semibold text-center">Status</div>
                                                </th>
                                                <th className="p-2">
                                                    <div className="font-semibold text-center">Updated By</div>
                                                </th>
                                                <th className="p-2">
                                                    <div className="font-semibold text-center">Updated On</div>
                                                </th>
                                                <th className="p-2">
                                                    <div className="font-semibold text-center"></div>
                                                </th>
                                            </tr>
                                        </thead>
                                        {/* Table body */}
                                        <tbody className="text-sm font-medium divide-y divide-gray-100">
                                            {/* Row */}
                                            {
                                                documents.map((doc, key) =>
                                                    <tr>
                                                        <td className="p-2">
                                                            <div className="text-center">{((page - 1) * limit) + key + 1}.</div>
                                                        </td>
                                                        <td className="p-2">
                                                            <div className="">{ doc.name }</div>
                                                            <p className="text-gray-500 mb-0 text-xs italic">Version { doc?.previous?.length + 1 }</p>
                                                        </td>
                                                        <td className="p-2">
                                                            <div className={ `text-center ${ doc.active ? 'text-green-500' : 'text-gray-700' }` }>{ doc.active ? 'Active' : 'Inactive' }</div>
                                                        </td>
                                                        <td className="p-2">
                                                            <div className="text-center">{ doc?.uploadedBy?.name }</div>
                                                        </td>
                                                        <td className="p-2">
                                                            <div className="text-center">{ stringifyDate(doc.date) }</div>
                                                        </td>
                                                        <td className="p-2 text-center">
                                                            <Dropdown
                                                                overlay={
                                                                    <Menu>
                                                                        <Menu.Item onClick={ () => select(doc) }>View</Menu.Item>
                                                                        <Menu.Item onClick={ () => toggleActive(doc) }>{ doc.active ? 'Deactivate' : 'Activate' }</Menu.Item>
                                                                        <Menu.Item onClick={ () => deleteDoc(doc) }>Delete Document</Menu.Item>
                                                                    </Menu>
                                                                }>
                                                                <a className="ant-dropdown-link flex items-center h-10" onClick={e => e.preventDefault()}><span className="mr-2">Actions</span> <AiOutlineDown /></a>
                                                            </Dropdown>
                                                        </td>
                                                    </tr>
                                                )
                                            }
                                        </tbody>
                                    </table>
                                :
                                    <div className="w-full h-16 flex items-center justify-center">
                                        <p className="font-semibold text-base">Please click above to add a new document</p>
                                    </div>
                            }
                        </Receive>
                        {Paginate}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Documents